import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, } from "@/components/ui/dialog";
import { decodeHTMLEntity } from "@/lib/utils";
import { Button } from "@/components/ui/button";
export default function FloorplanVirtualTourDialog(_a) {
    var floorplan = _a.floorplan;
    return (React.createElement(Dialog, null,
        React.createElement(DialogTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", className: "w-full text-center", size: "sm" }, "Property Video")),
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Property Video"),
                React.createElement(DialogDescription, null, decodeHTMLEntity(floorplan.title))),
            floorplan.propertyVideoEmbedCode ? (React.createElement("div", { className: "min-h-[60vh] w-full [&>iframe]:aspect-video", dangerouslySetInnerHTML: {
                    __html: floorplan.propertyVideoEmbedCode,
                } })) : (React.createElement("div", { className: "text-center py-6" },
                React.createElement("p", null, "No property video available"))))));
}
